import { Text } from '@sqs/rosetta-primitives';
import React from 'react';
import { usePlatformBreakpoint } from '../../hooks/usePlatformBreakpoint';
import { useI18n } from '../../i18n';
import { SchedulingInstancePermission } from '../../models/SchedulingInstance';

export const PermissionsMap = ({ permission }: {readonly permission?: SchedulingInstancePermission;}) => {
  const { isMobile } = usePlatformBreakpoint();
  const { T } = useI18n();

  let result;
  switch (permission) {
    case SchedulingInstancePermission.OWNER:
      result = <T project="enterprise-dashboard">{"Manager"}</T>;
      break;
    case SchedulingInstancePermission.ADMIN:
      result = <T project="enterprise-dashboard">{"Admin"}</T>;
      break;
    case SchedulingInstancePermission.VIEW:
      result = <T project="enterprise-dashboard">{"View Only"}</T>;
      break;
    case SchedulingInstancePermission.EDIT:
      result = <T project="enterprise-dashboard">{"View & Edit"}</T>;
      break;
    default:
      result = <T project="enterprise-dashboard">{"Unknown"}</T>;
      break;
  }
  if (isMobile) {
    return (
      <Text.Caption m={0} lineHeight={0} fontSize={3} color="black">
        {result}
      </Text.Caption>);

  }
  return <Text.Body m={0}>{result}</Text.Body>;
};